import routerOptions0 from "/home/runner/work/website/website/app/router.options.ts";
import routerOptions1 from "/home/runner/work/website/website/node_modules/.pnpm/nuxt@3.3.3_@types+node@18.11.18_eslint@8.33.0_typescript@4.9.4/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  strict: true
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}